/**
 * Generated by orval v7.2.0 🍺
 * Do not edit manually.
 * BVHI Product Data Platform
 * The backend service api is responsible for managing users, customer data, product catalogs, and api token.
 * OpenAPI spec version: 1.28.12
 */

/**
 * The type of the message.
 */
export type MessageType = (typeof MessageType)[keyof typeof MessageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageType = {
  TRANSPORT_ACKNOWLEDGEMENT: "TRANSPORT_ACKNOWLEDGEMENT",
  DESPATCH_ADVICE: "DESPATCH_ADVICE",
  INVOICE: "INVOICE",
  ORDER: "ORDER",
  TEST: "TEST",
  OTHER: "OTHER",
} as const;
